import PropTypes from "prop-types";
import React, {
	Component
}from "react";
import {
	TouchableOpacity,
	View,
} from "react-native";
import ResponsiveStylesheet from "react-native-responsive-stylesheet";

import InputLabel from "./Layout/InputLabel";
import InputContainer from "./Layout/InputContainer";
import inputStyle from "./Layout/intputStyle";
import StyledText from "ae-base/Base/StyledText";
import ErrorMessage from "./Layout/ErrorMessage";

import Style from "ae-style";

var radius = 10;

var styles = ResponsiveStylesheet.createSized("min-direction", {
	0: {
		container: {
			flexDirection: "row",
			alignItems: "center"
		},

		checkbox: {
			marginHorizontal: 1,
			borderRadius: radius + 7,
			width: 4 * radius,
			paddingTop: 3,
			paddingBottom: 3,
			paddingLeft: 3,
			paddingRight: 3
		},
		true: {
			alignItems: "flex-end"
		},
		false: {
			alignItems: "flex-start"
		},
		ball: {
			backgroundColor: Style.colors.primary,
			width: radius,
			height: radius,
			borderRadius: radius
		},
		spacing: {
			marginHorizontal: 3
		}
	},
	512: {
		container: {
			flexDirection: "row",
			alignItems: "center"
		},
		checkbox: {
			marginHorizontal: Style.layout.marginSmall,
			borderRadius: 18,
			width: 82,
			paddingTop: 7,
			paddingBottom: 7,
			paddingLeft: 7,
			paddingRight: 7
		},
		true: {
			alignItems: "flex-end"
		},
		false: {
			alignItems: "flex-start"
		},
		ball: {
			backgroundColor: Style.colors.primary,
			width: radius * 2,
			height: radius * 2,
			borderRadius: radius * 2
		},
		spacing: {
			marginHorizontal: 3
		}
	}
});

export default class AESwitch extends Component {

	constructor(props){
		super(props);

		this.state = {
			hasChanged: false,
			newValue: false
		};

		this.handleChange = handleChange.bind(this);
	}

	render(){
		var context = this.context;
		var localize = context.localize;
		var localizeFrom = context.localizeFrom;
		var schema = this.props.schema;
		var defaultValue = !!this.props.defaultValue;
		var newValue = this.state.newValue;
		var contrast = this.props.contrast;
		var errors = this.props.errors;
		var id = this.props.id;

		var hasChanged = this.state.hasChanged;

		var displayValue = hasChanged ? newValue : defaultValue;

		var onDescription, offDescription, valueDescriptionKey;

		var localizationMap = schema.value_localization || schema.valueLocalization;
		if(localizationMap){
			onDescription = localizeFrom(localizationMap, "true");
			offDescription = localizeFrom(localizationMap, "false");
		} else if(schema.value_description){
			valueDescriptionKey = schema.value_description;
		} else {
			valueDescriptionKey = "form.switch";
		}

		if(valueDescriptionKey){
			onDescription = localize(valueDescriptionKey + ".true");
			offDescription = localize(valueDescriptionKey + ".false");
		}

		var directionStyle = displayValue ? styles.true : styles.false;
		var checkStyle = [inputStyle.container, styles.checkbox, directionStyle];
		
		var label;
		if(schema !== undefined && schema.localization){
			label = localizeFrom(schema.localization, ".");
		} else if(schema !== undefined && schema.description) {
			label = localize(schema.description) || description;
		} else {
			label = "Switch Button"
		}

		if(errors && errors.length)
			checkStyle.push(inputStyle.errored);

		return (
			<InputContainer inline={this.props.inline}>
				<InputLabel schema={schema} />
				<ErrorMessage id={this.props.id + "_error"} errors={errors} schema={schema} />
				<View style={styles.container}>
					<TouchableOpacity id={context.id_prefix + id + "_false"} accessibilityComponentType="button" onPress={this.handleChange}>
						<StyledText contrast={contrast} style={styles.spacing}>{offDescription}</StyledText>
					</TouchableOpacity>
					<TouchableOpacity id={context.id_prefix + id} accessibilityLabel={label || "Switch Button"} accessibilityRole="switch" accessibilityState={{checked: hasChanged ? this.state.newValue : defaultValue}} accessibilityComponentType="button" style={checkStyle} onPress={this.handleChange}>
						<View style={styles.ball} />
					</TouchableOpacity>
					<TouchableOpacity id={context.id_prefix + id + "_true"} accessibilityComponentType="button" onPress={this.handleChange}>
						<StyledText contrast={contrast} style={styles.spacing}>{onDescription}</StyledText>
					</TouchableOpacity>
				</View>
			</InputContainer>
		);
	}
}

import types from "./Layout/inputTypes";

AESwitch.propTypes = types;

AESwitch.contextTypes = {
	id_prefix: PropTypes.string,
	localize: PropTypes.func,
	localizeFrom: PropTypes.func
};

function handleChange() {
	var hasChanged = this.state.hasChanged;
	var newValue = this.state.newValue;
	var defaultValue = this.props.defaultValue;

	var currentValue = hasChanged ? newValue : defaultValue;

	var updateValue = !currentValue;

	var onChange = this.props.onChange;
	if(onChange) onChange(updateValue);
	this.setState({
		newValue: updateValue,
		hasChanged: true,
	});
}
